export default __webpack_public_path__ + "static/media/pic3.f335a94c.jpg";